module.exports = __webpack_public_path__ + "img/copyright_mfer.94fd27d1.png";